import { ContractStatus } from '../types'

export const PRODUCT_UNITS = (t: Function) => [
    { value: 'qty', label: t('qty') },
    { value: 'pack/ day', label: t('pack/ day') },
    { value: 'pack/ month', label: t('pack/ month') },
    { value: 'pack/ year', label: t('pack/ year') },
    { value: 'domain', label: t('domain') },
    { value: 'hour', label: t('hour') },
    { value: 'hours', label: t('hours') },
    { value: 'bytes', label: t('bytes') },
    { value: 'kb', label: t('kb') },
    { value: 'mb', label: t('mb') },
    { value: 'gb', label: t('gb') },
    { value: 'tb', label: t('tb') },
    { value: 'pb', label: t('pb') },
    { value: 'mbps', label: t('mbps') },
    { value: 'gbps', label: t('gbps') },
    { value: 'tbps', label: t('tbps') },
    { value: 'pbps', label: t('pbps') },
    { value: 'package', label: t('package') },
    { value: 'milion-requests', label: t('milion-requests') },
    { value: 'milion-queries', label: t('milion-queries') },
    { value: 'queries', label: t('queries') },
    { value: 'k-queries', label: t('k-queries') },
    { value: 'requests', label: t('requests') },
    { value: 'k-requests', label: t('k-requests') },
    { value: 'key', label: t('key') },
    { value: 'rules', label: t('rules') },
    { value: 'fqnd', label: t('fqnd') },
    { value: 'pack/ site', label: t('pack/ site') },
    { value: 'w', label: t('w') },
    { value: 'core', label: t('core') },
    { value: 'u', label: t('u') },
    { value: 'gbminutes', label: t('gbminutes') },
    { value: 'server', label: t('server') },
    { value: 'stream', label: t('stream') },
    { value: 'months', label: t('months') },
    { value: 'days', label: t('days') },
]

export const PRODUCT_TRANSCODING_UNITS = (t: Function) => [
    { value: 'hour', label: t('hour') },
    { value: 'stream', label: t('stream') },
]

export const PRODUCT_FORM = (t: Function) => [
    {
        label: t('not_commit'),
        value: 'not_commit',
    },
    {
        label: t('commit'),
        value: 'commit',
    },
]

export const PRICE_CONFIG = (t: Function) => [
    {
        label: t('tierd'),
        value: 'tierd',
    },
    {
        label: t('progressive'),
        value: 'progressive',
    },
]

export const COMMITMENT_PREPAID = (t: Function) => [
    {
        label: t('prepay'),
        value: true,
    },
    {
        label: t('paylater'),
        value: false,
    },
]

export const PRIVATE_DOMAIN_BILLING_CYCLE = [
    { value: 'annually', label: '1 năm', number: 1 },
    { value: 'biennially', label: '2 năm', number: 2 },
    { value: 'triennially', label: '3 năm', number: 3 },
    { value: 'quadrennial', label: '4 năm', number: 4 },
    { value: 'quinquennial', label: '5 năm', number: 5 },
    { value: 'sexennial', label: '6 năm', number: 6 },
    { value: 'septennial', label: '7 năm', number: 7 },
    { value: 'octennial', label: '8 năm', number: 8 },
    { value: 'novennial', label: '9 năm', number: 9 },
    { value: 'decennial', label: '10 năm', number: 10 },
]

export const CONTRACT_STATUS = (t: Function) => [
    {
        value: ContractStatus.Active,
        label: t('contract-active'),
        color: 'success',
    },
    {
        value: ContractStatus.Uploading,
        label: t('contract-uploading'),
        color: 'warning',
    },
    {
        value: ContractStatus.Pending,
        label: t('contract-pending'),
        color: 'primary',
    },
    {
        value: ContractStatus.Exchanging,
        label: t('contract-exchanging'),
        color: 'info',
    },
    {
        value: ContractStatus.Outdate,
        label: t('contract-outdate'),
        color: 'error',
    },
    {
        value: ContractStatus.Retained,
        label: t('contract-retained'),
        color: 'error',
    },
]

export const CONTRACT_SLA_OPTIONS = (t: Function) => [
    {
        value: true,
        label: t('sla'),
        color: 'success',
    },
    {
        value: false,
        label: t('no-sla'),
        color: 'info',
    },
]

export const CONTRACT_NDA_OPTIONS = (t: Function) => [
    {
        value: true,
        label: t('nda'),
        color: 'success',
    },
    {
        value: false,
        label: t('no-nda'),
        color: 'info',
    },
]
export const CONTRACT_RENEW_OPTIONS = (t: Function) => [
    {
        value: true,
        label: t('auto_renewable'),
        color: 'success',
    },
    {
        value: false,
        label: t('no-auto_renewable'),
        color: 'info',
    },
]

const translateContractOption = (
    t: Function,
    key: string,
    fallback: string
) => {
    const translated = t(key)
    if (translated !== key) return translated

    const namespacedKey = `contract:${key}`
    const namespaced = t(namespacedKey)
    if (namespaced !== namespacedKey) return namespaced

    return fallback
}

export const CONTRACT_ROLE_OPTIONS = (t: Function) => [
    {
        value: 'customer',
        label: translateContractOption(
            t,
            'contract_roles.customer',
            'Customer'
        ),
        color: 'primary',
    },
    {
        value: 'supplier',
        label: translateContractOption(
            t,
            'contract_roles.supplier',
            'Supplier'
        ),
        color: 'warning',
    },
    {
        value: 'reseller',
        label: translateContractOption(
            t,
            'contract_roles.reseller',
            'Reseller'
        ),
        color: 'info',
    },
    {
        value: 'affiliate',
        label: translateContractOption(
            t,
            'contract_roles.affiliate',
            'Affiliate'
        ),
        color: 'success',
    },
    {
        value: 'collaborator',
        label: translateContractOption(
            t,
            'contract_roles.collaborator',
            'Collaborator'
        ),
        color: 'secondary',
    },
]

export const CONTRACT_DIRECTION_OPTIONS = (t: Function) => [
    {
        value: 'earn',
        label: translateContractOption(t, 'contract_directions.earn', 'Output'),
        color: 'success',
    },
    {
        value: 'pay',
        label: translateContractOption(t, 'contract_directions.pay', 'Input'),
        color: 'error',
    },
]

export const CUSTOMER_CONTRACT_TYPE_LABELS = {
    Summary: 'contract-summaries',
    Created: 'contract-new',
    Exchanging: 'contract-exchanging',
    Expiried: 'contract-expiried',
    Uploading: 'contract-uploading',
    Completed: 'contract-completed',
}

export const UNLIMITED = 999_999_999

export const SAMPLE_CONTRACT_TYPES = (t: Function) => [
    {
        value: 'sample',
        label: t('samples.sample'),
    },
    {
        value: 'sla',
        label: t('samples.sla'),
    },
    {
        value: 'nda',
        label: t('samples.nda'),
    },
]

export const PRICING_MODELS = {
    Package: 'package',
    Bundle: 'bundle',
    PercentPerParent: 'percent_per_parent',
}

export const SERVICE_PRICING_MODELS = (t: Function) => [
    {
        value: PRICING_MODELS.Package,
        label: t('pricing_models.package'),
    },
    {
        value: PRICING_MODELS.Bundle,
        label: t('pricing_models.bundle'),
    },
    {
        value: PRICING_MODELS.PercentPerParent,
        label: t('pricing_models.percent_per_parent'),
    },
]
